import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { appConstants } from '../../../constants';
import { EventManagerService } from '../event-manager.service';
import { SocketConnect } from './socket-connect';
import { BehaviorSubject } from 'rxjs';
import {isPlatformBrowser} from "@angular/common";
import {EventService} from "@cybfed/core/store/event.service";

@Injectable({
  providedIn: 'root',
})
export class SocketMainService {
  public static connection = new BehaviorSubject<boolean | null>(null);
  private joinedRooms = new Set<string>();

  constructor(
      public socket: SocketConnect,
      @Inject(PLATFORM_ID) private platformId: any,
      private eventManager: EventManagerService,
      private eventService: EventService
  ) {
    if(isPlatformBrowser(this.platformId) && !SocketMainService.connection.value){console.log('mtav socket browser')
      // if (!SocketMainService.connection.value ) {
        this.initializeSocket();
        SocketMainService.connection.next(false);
      // }
      // // Subscribe to connection status changes
      // SocketMainService.connection.subscribe((status) => {
      //   if (status) {
      //     let interval = setInterval(()=> {
      //       // If reconnected, rejoin all previous rooms
      //       this.rejoinRooms();
      //       clearInterval(interval);
      //     },1000)
      //   }
      // });
    }

  }

  private initializeSocket() {
    this.socket.on('connect', () => {
      console.log('Connected');
      SocketMainService.connection.next(true);
      this.rejoinRooms();
      this.eventService.connectToWidgetSocket.emit();
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected');
      SocketMainService.connection.next(false);
    });

    this.socket.on('logInfo', (data: any) => {
      console.log('socket logInfo', data);
    });
  }

  joinRoom(eventType = appConstants.EVENTTYPES.USER, forId: any = null) {
    const roomKey = JSON.stringify({ eventType, forId });
    this.socket.emit('join', { eventType, forId });
    if (!this.joinedRooms.has(roomKey)) {
      this.joinedRooms.add(roomKey); // Track joined rooms uniquely
    }
  }

  unJoinRoom(eventType = appConstants.EVENTTYPES.USER, forId: any = null) {
    const roomKey = JSON.stringify({ eventType, forId });
    if (this.joinedRooms.has(roomKey)) {
      this.socket.emit('leave', { eventType, forId });
      this.joinedRooms.delete(roomKey);
    }
  }

  listenToEventWithCallback(actionType: any, eventType: any, callback: any) {
    this.socket.on(actionType + '_' + eventType, callback);
  }

  listenToEventWithEventManager(actionType: string) {
    this.socket.on(actionType, (data: any) => {
      this.eventManager.socketDataListener.emit(data);
    });
  }

  disconnect() {
    this.socket.disconnect();
  }

  private rejoinRooms() {
    this.joinedRooms.forEach((roomKey) => {
      const { eventType, forId } = JSON.parse(roomKey);
      console.log(this.socket);
      this.joinRoom(eventType, forId);
    });
  }
}
